import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/DraftsStatuses';

import { OperationType } from '../../model/operation';
import { Channel } from '../../model/skill';

const t = i18n(keyset);

const getCommonStrings = (): Record<OperationType, string> => ({
    skillCreated: t('created'),
    skillWithdrawn: t('withdrawn'),
    skillStopped: t('stopped'),
    skillDeleted: t('deleted'),
    reviewRequested: t('review-requested'),
    reviewCancelled: t('review-cancelled'),
    reviewCancelledByUser: t('review-cancelled'),
    reviewApproved: t('review-approved'),
    deployRequested: t('deploy-requested'),
    deployCompleted: t('deploy-complete'),
    deployRejected: t('deploy-rejected'),
    settingsReviewApproved: '',
    deviceTestPrepared: '',
    deviceTestStarted: '',
    deviceTestCompleted: '',
    skillNominated: t('skill-nominated'),
    skillNominationRotationCompleted: t('skill-nomination-cancelled'),
    skillNominationRotationWithdrawn: t('skill-nomination-cancelled'),
});

const getSmartHomeStrings = (): Record<OperationType, string> => ({
    skillCreated: t('dialog-created'),
    skillWithdrawn: t('dialog-withdrawn'),
    skillStopped: t('dialog-stopped'),
    skillDeleted: t('dialog-deleted'),
    reviewRequested: t('review-requested'),
    reviewCancelled: t('review-cancelled'),
    reviewCancelledByUser: t('review-cancelled'),
    reviewApproved: t('review-approved'),
    deployRequested: t('deploy-requested'),
    deployCompleted: t('deploy-complete'),
    deployRejected: t('deploy-rejected'),
    settingsReviewApproved: t('sh-meeting'),
    deviceTestPrepared: t('sh-waiting'),
    deviceTestStarted: t('sh-testing'),
    deviceTestCompleted: t('sh-analysis'),
    skillNominated: '',
    skillNominationRotationCompleted: '',
    skillNominationRotationWithdrawn: '',
});

export const getOperationLabelsTranslated = (channel: Channel) => {
    if (channel === Channel.SmartHome) return getSmartHomeStrings();
    return getCommonStrings();
};
